<template>
  <v-idle
    @idle="onidle"
    @remind="onremind"
    :loop="false"
    :reminders="reminders"
    :wait="wait"
    :duration="duration"
    :events="['click', 'mousemove', 'keypress']"
  />
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["duration", "wait", "reminders"],

  data() {
    return {
      isReminding: false,
    };
  },

  computed: {},

  methods: {
    ...mapActions(["setIsIdle"]),

    onidle() {
      window.location = "https://www.chesssquad.com";
    },

    onremind(remain) {
      if (this.isReminding) {
        return;
      }

      this.isReminding = true;
      this.setIsIdle(true);

      const durationMinutes = Math.floor(this.duration / 60);
      const remainMinutes = Math.floor(remain / 60);

      this.$buefy.dialog.alert({
        title: "Warning",
        message: `You have been idle for ${durationMinutes -
          remainMinutes} minutes. We are going to log you out in ${remainMinutes} minutes. Click on Stay to continue`,
        type: "is-warning",
        hasIcon: true,
        icon: "hourglass-end",
        iconPack: "fa",
        confirmText: "Stay",
        onConfirm: () => {
          this.isReminding = false;
          this.setIsIdle(false);
        },
      });
    },
  },
};
</script>

<style></style>
